var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "1 1 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.237 6.048c.725-.726 1.99-.726 2.716 0l.452.452.905-.905-.452-.453a3.178 3.178 0 00-2.263-.937c-.855 0-1.66.333-2.263.937L1.973 6.5a3.206 3.206 0 001.039 5.22c.388.161.804.243 1.224.243a3.19 3.19 0 002.264-.936l.453-.453-.906-.905-.452.452a1.925 1.925 0 01-2.716 0 1.924 1.924 0 010-2.716l1.358-1.357z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 1.973l-.453.453.905.905.453-.452a1.925 1.925 0 012.716 0 1.923 1.923 0 010 2.716L8.763 6.953c-.726.725-1.99.725-2.716 0L5.595 6.5l-.906.905.453.453a3.178 3.178 0 002.263.938c.855 0 1.66-.334 2.263-.938L11.026 6.5a3.206 3.206 0 000-4.527 3.204 3.204 0 00-4.526 0z"
  })));
}
export default SvgLinkIcon;